// Fire Shield Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle
  window.toggleMobileMenu = function() {
    const menu = document.getElementById('mobileMenu');
    if (menu) {
      menu.classList.toggle('hidden');
    }
  };

  // Counter animation
  const counters = document.querySelectorAll('.spec-number[data-target]');
  const speed = 200;

  const animateCounters = () => {
    counters.forEach(counter => {
      const target = counter.getAttribute('data-target');
      const count = parseInt(counter.innerText) || 0;

      if (target === '0') {
        counter.innerText = 'UL';
        return;
      }

      const targetNum = parseInt(target);
      const inc = targetNum / speed;

      if (count < targetNum) {
        counter.innerText = Math.min(Math.ceil(count + inc), targetNum);
        setTimeout(animateCounters, 20);
      } else {
        counter.innerText = targetNum;
      }
    });
  };

  // Intersection Observer for counters
  if (counters.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounters();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Add to cart functionality with feedback
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      const button = this.querySelector('button[type="submit"]');
      if (button) {
        const originalText = button.innerText;
        button.innerText = 'Adding...';
        button.disabled = true;

        setTimeout(() => {
          button.innerText = 'Added!';
          button.style.backgroundColor = '#059669';

          setTimeout(() => {
            button.innerText = originalText;
            button.disabled = false;
            button.style.backgroundColor = '';
          }, 2000);
        }, 500);
      }
    });
  });

  // GSAP Animations (if GSAP is loaded)
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Fade in sections on scroll
    const animateElements = document.querySelectorAll('.professional-card, .testimonial-card');
    if (animateElements.length > 0) {
      animateElements.forEach((element, i) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          },
          opacity: 0,
          y: 30,
          duration: 0.6,
          delay: i * 0.1
        });
      });
    }
  }
});
